import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset to 24 hours when it reaches 0
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const TimeBlock = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-13">
      <motion.div key={value} initial={{
      scale: 1.1
    }} animate={{
      scale: 1
    }} className="bg-navy-900 text-amber-400 rounded-lg px-3 py-2 sm:px-4 sm:py-3 min-w-[60px] sm:min-w-[80px]" data-id="element-14">
        <span className="text-2xl sm:text-4xl font-bold font-mono" data-id="element-15">
          {value.toString().padStart(2, '0')}
        </span>
      </motion.div>
      <span className="text-xs sm:text-sm text-navy-600 mt-2 font-medium uppercase tracking-wide" data-id="element-16">
        {label}
      </span>
    </div>;
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-gradient-to-r from-amber-50 to-cream-100 border-2 border-amber-200 rounded-2xl p-6 sm:p-8 shadow-lg max-w-2xl mx-auto mb-8" data-id="element-17">
      <div className="flex items-center justify-center mb-4" data-id="element-18">
        <Clock className="w-5 h-5 text-amber-600 mr-2" data-id="element-19" />
        <p className="text-sm sm:text-base font-semibold text-navy-800 uppercase tracking-wide" data-id="element-20">
          ⚡ Oferta termina en:
        </p>
      </div>

      <div className="flex items-center justify-center gap-3 sm:gap-6" data-id="element-21">
        <TimeBlock value={timeLeft.hours} label="Horas" data-id="element-22" />
        <span className="text-3xl sm:text-5xl font-bold text-navy-800 pb-6" data-id="element-23">
          :
        </span>
        <TimeBlock value={timeLeft.minutes} label="Minutos" data-id="element-24" />
        <span className="text-3xl sm:text-5xl font-bold text-navy-800 pb-6" data-id="element-25">
          :
        </span>
        <TimeBlock value={timeLeft.seconds} label="Segundos" data-id="element-26" />
      </div>
    </motion.div>;
}